export const API_BASE_URL = process.env.NODE_ENV === 'development'
    ? "http://localhost/christian-videos-app/web/api/index.php"
    : "/api/index.php";
